module.exports = {
  social_deduction_games_online: {
    title: 'Social Deduction Games for Friends | Avalon',
    description:
      'Compare four games for 5–10 friends: browser or installed, voting and elimination. Try Avalon solo with bots.',
    keywords: ['social deduction games'],
    breadcrumbs: [
      {
        to: '/',
        title: 'Home',
      },
      {
        to: '/guides/social-deduction-games-online/',
        title: 'Social deduction games',
      },
    ],
  },
  games_like_secret_hitler: {
    title: 'Games Like Secret Hitler: Try Avalon',
    description:
      'Compare Secret Hitler with Avalon: hidden teams, votes and mission cards. Play with friends or learn with bots.',
    keywords: ['games like Secret Hitler'],
    breadcrumbs: [
      {
        to: '/',
        title: 'Home',
      },
      {
        to: '/guides/social-deduction-games-online/',
        title: 'Social deduction games',
      },
      {
        to: '/guides/games-like-secret-hitler/',
        title: 'Games like Secret Hitler',
      },
    ],
  },
  avalon_vs_werewolf: {
    title: 'Games Like Werewolf and Mafia: Avalon',
    description:
      'Compare elimination, roles and voting in Avalon, Werewolf and Mafia. Try Avalon in your browser with friends or bots.',
    keywords: ['games like werewolf'],
    breadcrumbs: [
      {
        to: '/',
        title: 'Home',
      },
      {
        to: '/guides/social-deduction-games-online/',
        title: 'Social deduction games',
      },
      {
        to: '/guides/avalon-vs-werewolf/',
        title: 'Avalon vs Werewolf',
      },
    ],
  },
};
